export const licenses = (state) => state.licenses
export const getLicense = (state) => state.license
export const isLoading = (state) => state.loading
export const getLicenseList = (state) => state.licenseList
export const isListLoading = (state) => state.listLoading
export const getApiConfig = (state) => state.apiConfig
export const isConfigured = (state) => !!(state.apiConfig?.public_key)
export const getLicencesPermissions = (state) => state.licenses.flatMap(licence => licence.permission?.permissions || [])
